import { QueryClient } from '@tanstack/react-query';
import { shouldRetryQuery } from '../utils/queryRetry';

const ONE_MINUTE = 60 * 1000;
const FOUR_HOURS = 4 * 60 * 60 * 1000;
// For queries carrying GCS signed URLs (10 min to 1 h): an unused entry drops before its links expire.
export const SIGNED_URL_GC_TIME_MS = 5 * 60 * 1000;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: ONE_MINUTE,
            gcTime: FOUR_HOURS,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            retry: shouldRetryQuery,
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
        }
    }
});
